import React, { useCallback, useMemo } from "react";
import Tabs from "../components/Tabs/Tabs";
import { defineProperties } from "../translationService";
import { Switch, Route, useLocation } from "react-router-dom";
import { ERoute } from "../helpers/Routes";
import { UserBookingsScreen } from "./screens/Bookings";
import { UserBillsScreen } from "./screens/Bills";
import { UserPaymentsScreen } from "./screens/Payments";
import { UserMessagesScreen } from "./screens/Messages";
import { AuthIndex } from "./screens/AuthIndex";
import withAuthentication from "./layout/withAuthentication";
import { getHashOrPath, redirectToPage } from "../helpers";
import { useAuthMode } from "./rx/useAuthMode";
import { useIsMobile } from "../helpers/useIsMobile";
import keyBy from "lodash/keyBy";
import { shallowEqual, useSelector } from "react-redux";
var tabs = [
    defineProperties({ key: ERoute.USER_BOOKINGS, Component: UserBookingsScreen }, { label: "user_entity.tabs.bookings" }),
    defineProperties({ key: ERoute.USER_BILLS, Component: UserBillsScreen }, { label: "user_entity.tabs.bills" }),
    defineProperties({ key: ERoute.USER_PAYMENTS, Component: UserPaymentsScreen }, { label: "user_entity.tabs.payments" }),
    defineProperties({ key: ERoute.USER_MESSAGES, Component: UserMessagesScreen }, { label: "user_entity.tabs.messages" }),
];
var summaryTabs = [];
export var AuthScreen = withAuthentication(function AuthLayout() {
    var activeTab = useLocation().pathname;
    var authEntities = useSelector(function (state) {
        var _a;
        return (_a = state.courseReducer.authEntities) !== null && _a !== void 0 ? _a : [];
    }, shallowEqual);
    var onActiveTabChange = useCallback(function (activeTab) {
        redirectToPage(getHashOrPath(activeTab.key));
    }, []);
    var isMobile = useIsMobile();
    var isInlineTabs = useAuthMode() === "tabs-inline" || isMobile;
    var config = useAuthMode() !== 'summary' ? { tabs: tabs, } : { tabs: summaryTabs, };
    var orderedTabs = useMemo(function () {
        var keyByTabPath = keyBy(config.tabs, 'key');
        var validEntities = authEntities.filter(function (key) { return keyByTabPath['/user/' + key]; });
        if (validEntities.length)
            return validEntities.map(function (key) { return keyByTabPath['/user/' + key]; }).filter(Boolean);
        return config.tabs;
    }, [config.tabs]);
    return (React.createElement(Tabs, { activeTab: activeTab, horizontal: isInlineTabs, tabs: orderedTabs, onActiveTabChange: onActiveTabChange, hideTabsIfOnlyTab: true },
        React.createElement(Switch, null,
            orderedTabs.map(function (tab) { return React.createElement(Route, { key: tab.key, path: tab.key, component: tab.Component }); }),
            React.createElement(Route, { exact: true, path: ERoute.USER_ACCOUNT, component: AuthIndex }))));
});
